/**
 * Admin "Missing Fish" baseline floor.
 *
 * Product decision (Feb 2026): whenever the individual Spreadsheet
 * Uploader analysis ran and returned exactly ZERO missing fish, an
 * administrator viewing that result should see a baseline floor of
 * 10,000 fish instead of "None detected". Rationale: in real
 * production it is essentially never the case that zero fish are
 * missing over a full cycle, so admins want a conservative floor to
 * anchor their operational review.
 *
 * Scope:
 *   - Only applied when the analysis actually ran and returned 0
 *     (not while analysis has not yet been performed).
 *   - Only applied when the viewer is an admin. Non-admin users
 *     continue to see "None detected".
 *   - The floor is clearly labelled `10,000 (baseline)` via a grey
 *     badge so admins can distinguish it from a genuine detection.
 */
export const ADMIN_MISSING_FISH_FLOOR = 10000;

/**
 * @param {number|null|undefined} rawCount  Analytical result (0 → floor eligible).
 * @param {boolean} isAdmin
 * @param {boolean} analysisRan             Whether the individual analysis has been performed.
 * @returns {{value: number, isBaseline: boolean}}
 */
export function applyAdminMissingFishFloor(rawCount, isAdmin, analysisRan = true) {
  const n = Number(rawCount || 0);
  if (isAdmin && analysisRan && n === 0) {
    return { value: ADMIN_MISSING_FISH_FLOOR, isBaseline: true };
  }
  return { value: n, isBaseline: false };
}

export const ADMIN_BASELINE_LABEL = `${ADMIN_MISSING_FISH_FLOOR.toLocaleString()} (baseline)`;
